import 'dayjs/locale/es';

import { useQuery } from '@apollo/client';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { UserIcon } from '../assets';
import { Breadcrumbs } from '../components/common/Breadcrumbs';
import { LateralProfileMenu } from '../components/common/LateralProfileMenu';
import ProfileTabs from '../components/common/ProfileTabs';
import { BrandForm } from '../components/users/brandForm';
import { ROUTES } from '../config/routes/config';
import { GET_BRAND } from '../graphql/brands/query';
import { GET_PROFILE } from '../graphql/user/query';
import { userAtom } from '../states/atoms';
import type { ResponseProfile } from '../types';

declare global {
  interface Window {
    BeforeInstallPromptEvent: Event;
    deferredPrompt: any;
    installedApp: boolean;
  }
}

dayjs.extend(localizedFormat);
dayjs.locale('es');

function Profile() {
  const { t } = useTranslation('common');
  const myUser = useRecoilValue(userAtom);
  const location = useLocation();
  const [user, setUser] = useState<any>();

  const { refetch: refetchUser } = useQuery<ResponseProfile>(GET_PROFILE, {
    onCompleted: (data) => {
      setUser(data.profile.data);
    },
    notifyOnNetworkStatusChange: true,
  });

  const handleInstallAppClick = async () => {
    if (window.deferredPrompt) {
      window.deferredPrompt.prompt();
      const { outcome } = await window.deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        // eslint-disable-next-line no-console
        console.log('User accepted the install prompt');
      } else {
        // eslint-disable-next-line no-console
        console.log('User dismissed the install prompt');
      }
      window.deferredPrompt = null; // Reset the deferred prompt
    }
  };

  const { data, refetch } = useQuery(
    // const { loading } = useQuery<ResSingleCampaignType>(
    GET_BRAND,
    {
      variables: {
        brandId: user && user.brand_id ? user.brand_id : '',
      },
      onError: () => {
        // TODO: SHOW MISSING CAMPAIGN ID NOTIFICATION
      },
      skip: !(user && user.brand_id),
    },
  );

  return (
    <div className="w-full flex flex-col gap-y-5">
      <div className="h-[32px] flex items-center">
        <Breadcrumbs
          icon={<UserIcon />}
          breadcrumbs={[
            {
              text: t('profile.title'),
              link: ROUTES.PROFILE,
            },
            {
              text: t('profile.menu.title4'),
            },
          ]}
        />
      </div>
      {user && (
        <>
          {user && (
            <>
              <div className="lg:hidden flex flex-row gap-5">
                <ProfileTabs location={location} user={user} myUser={myUser} />
              </div>
              <div className="flex flex-row gap-12">
                {!location.pathname.includes('user') && (
                  <div className="h-screen sticky top-0 lg:flex hidden">
                    <LateralProfileMenu
                      user={user}
                      isProfile={user.id === myUser.id}
                      isBrand={myUser.role === 'Brand'}
                    />
                  </div>
                )}
                <BrandForm info={data?.brand?.data} refetch={refetch} />
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default Profile;
